import { ref, onUnmounted } from "vue"
import moment, { type Moment } from "moment"

/**
 * Returns a reactive `Moment` ref that updates every time the minute changes.
 * Useful for driving computed properties that depend on the current time.
 *
 * The timer aligns itself to the start of each new minute so updates
 * happen as close to the :00 second mark as possible.
 */
export function useMinuteClock() {
  const now = ref<Moment>(moment())

  let timer: ReturnType<typeof setTimeout>

  function scheduleNextTick() {
    const msUntilNextMinute = 60_000 - (Date.now() % 60_000)
    timer = setTimeout(() => {
      now.value = moment()
      scheduleNextTick()
    }, msUntilNextMinute)
  }

  scheduleNextTick()

  onUnmounted(() => {
    clearTimeout(timer)
  })

  return now
}
